import request from '@/api/request.js'

// 新增
export function PaperVSOrganizationInsert(data) {
    return request({
        url: '/api/paper/papervsorganizationinsert',
        method: 'post',
        data: data
    })
}

// 新增
export function PaperVSOrganizationInsertMany(data) {
    return request({
        url: '/api/paper/papervsorganizationinsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function PaperVSOrganizationDelete(id) {
    return request({
        url: `/api/paper/papervsorganizationdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function PaperVSOrganizationUpdate(id, data) {
    return request({
        url: `/api/paper/papervsorganizationupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function PaperVSOrganizationGetById(id) {
    return request({
        url: `/api/paper/getpapervsorganizationbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function PaperVSOrganizationGetList(params) {
    return request({
        url: '/api/paper/getpapervsorganizationlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function PaperVSOrganizationGetPageList(params) {
    return request({
        url: '/api/paper/getpapervsorganizationpagelist',
        method: 'get',
        params: params
    })
}